export default __webpack_public_path__ + "static/media/snowuns-text1.60376211.webp";